module.exports = __webpack_public_path__ + "static/img/illustratepic_02_jp.0a3f11b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/illustratepic_02_jp.png
// module id = l4JU
// module chunks = 1